<template>
  <div>
    <a-form class="form leader-project-form" layout="vertical">
      <h3>Шаг 8. Научные направления</h3>

      <a-form-item>
        <c-input-udc-list
          :items="model.scientificScopes"
          :project-id="route.params.id"
          :disabled="true"
          :show-selector="false"
        >
          <template #selected-header
            ><snap class="udc-selection-header">Вы выбрали:</snap></template
          >
        </c-input-udc-list>
      </a-form-item>

      <a-divider />

      <p>Выберите, к каким научным направлениям относится проект.</p>

      <a-flex class="scopes">
        <project-udc-item
          v-for="item in mainUdc"
          :key="'udc-' + item.notation"
          :item="item"
          :disabled="true"
        />
      </a-flex>
    </a-form>
  </div>
</template>

<script setup>
  import { onMounted, reactive, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import ProjectUdcItem from '@/components/projects/components/ProjectUdcItem.vue';
  import CInputUdcList from '@/components/UI/CInputUdcList.vue';
  import ScientificScopesAdapter from '@/api/udc/scientific-scopes-adapter';

  const route = useRoute();
  const api = useApi();
  const mainUdc = ref([]);

  const props = defineProps({
    project: {
      type: Object,
      require: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const model = reactive({
    id: null,
    isExternal: false,
    udcStepPassed: false,
    availabilityList: [],
    scientificScopes: [],
  });

  onMounted(async () => {
    fillModel();
    await getMainUdc();
  });

  const fillModel = () => {
    try {
      model.id = props.project.id;
      model.isExternal = props.project.isExternal;
      model.udcStepPassed = props.project.udcStepPassed;
      model.availabilityList = props.project.availabilityList;
      model.scientificScopes = new ScientificScopesAdapter().convertMany(
        props.project.scientificScopes
      );
    } catch (error) {
      console.error('error', error);
    }
  };

  const getMainUdc = async () => {
    try {
      // Для получения главных УДК в поиске topUdcId = null (не указываем в параметрах)
      const response = await api.udc.getDescendants(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      mainUdc.value = response.udcList.items;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .ant-form-item {
    margin-bottom: 0;
  }

  :deep(.ant-input) {
    font-family: 'Nunito Sans', sans-serif;

    &[disabled] {
      color: $color-text-primary;
    }
  }

  :deep(.leader-project-form__available) {
    padding-top: 8px;
  }

  .scopes {
    flex-direction: column;
    row-gap: 8px;
    margin-bottom: 50px;
  }

  .udc-selection-header {
    font-family: Nunito Sans, sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    vertical-align: middle;
    margin-bottom: 16px;
  }
</style>
